import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-message', 'close', 'Aizvērt');
